import OrganizationChannelList from './holders/OrganizationChannelList'
import OrganizationContactInfo from './holders/OrganizationContactInfo'
import OrganizationCourseList from './holders/OrganizationCourseList'
import OrganizationEventList from './holders/OrganizationEventList'
import OrganizationInfo from './holders/OrganizationInfo'
import OrganizationNews from './holders/OrganizationNews'
import {OrganizationDepartmentsGrid} from "./holders/OrganizationDepartments";

export const organizationRouteEntities = [
  {
    path: 'overview',
    component: OrganizationInfo,
    breadcrumbName: (t) => t('overview'),
  },
  // {
  //   path: 'hosts',
  //   component: OrganizationHostList,
  //   breadcrumbName: (t) => t('related units'),
  // },
  {
    path: 'news',
    component: OrganizationNews,
    breadcrumbName: (t) => t('news'),
  },
  {
    path: 'groups',
    component: OrganizationDepartmentsGrid,
    breadcrumbName: (t) => t('groups / ministries'),
  },
  {
    path: 'channels',
    component: OrganizationChannelList,
    breadcrumbName: (t) => t('channels'),
  },
  {
    path: 'events',
    component: OrganizationEventList,
    breadcrumbName: (t) => t('events'),
  },
  {
    path: 'courses',
    component: OrganizationCourseList,
    breadcrumbName: (t) => t('courses'),
  },
  // {
  //   path: 'products',
  //   component: OrganizationProductList,
  //   breadcrumbName: (t) => t('product-service'),
  // },
  {
    path: 'contacts',
    component: OrganizationContactInfo,
    breadcrumbName: (t) => t('contact'),
    // isInvisible: (organization) => _.isEmpty(organization?.contacts),
  },
]
